import * as React from 'react';
export const openphoneSvg = React.forwardRef(function openphoneSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#6439F5',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M19.261 7.245a8.757 8.757 0 0 1 4.294 16.385 8.755 8.755 0 0 1-10.586-1.543 6.566 6.566 0 0 0 0-12.174 8.732 8.732 0 0 1 6.214-2.668h.078Zm-13.978 4.77a6.567 6.567 0 0 1 7.686-2.102 8.755 8.755 0 0 0 0 12.174 6.567 6.567 0 0 1-7.686-10.071Z',
      fill: '#fff',
    }),
  );
});
openphoneSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var openphone = {
  category: 'brand',
  colorable: false,
  name: 'openphone',
  svg: openphoneSvg,
};
